export enum EvvStatusHomeHealthEnum {
    NotStarted = 0,
    InProgress = 1,
    PatientVerified = 2,
    ClinicianVerified = 3
}
